import { AddDeviceInput, AddServiceInput, ModelType } from "../../API";
import { configurationParametersByModelType } from "../../pages/model-manager/variables/modelManager";
import { modelToServiceMap } from "../variables/common";

type ParsedTemplate = {
  model: string[];
};

const DOCKER_IMAGE_MODEL_MAP: Record<string, string> = {
  agg: "gateguard",
  tlm: "tanklevel",
};

export const mapTemplateDataToServiceInput = (
  devices: AddDeviceInput[],
  parsedTemplateData: ParsedTemplate[]
): Omit<AddServiceInput, "timeZone">[] => {
  const serviceInputs: Omit<AddServiceInput, "timeZone">[] = [];

  devices.forEach((device, index) => {
    const template = parsedTemplateData[index];

    template.model.forEach(modelTypeRaw => {
      const modelType = modelTypeRaw.toLowerCase() as ModelType;

      const serviceType = modelToServiceMap[modelType];

      if (!serviceType) {
        throw new Error(`Unknown model type: "${modelTypeRaw}"`);
      }

      const dockerImageModel = DOCKER_IMAGE_MODEL_MAP[modelType] || modelType;

      const baseConfiguration = (configurationParametersByModelType[
        modelType
      ] ?? {}) as Record<string, unknown>;

      const fullConfiguration = {
        docker_image: `534256877503.dkr.ecr.us-east-1.amazonaws.com/ccai-${dockerImageModel}:latest`,
        ...baseConfiguration,
      };

      serviceInputs.push({
        serviceType,
        nodeId: device.nodeId,
        deviceId: `DE#${device.name}`,
        locationId: device.locationId,
        customerId: device.customerId,
        configuration: JSON.stringify(fullConfiguration),
      });
    });
  });

  return serviceInputs;
};
